import { ODSDatePicker } from '@telekom-ods/react-ui-kit';
import PropTypes from 'prop-types';

const flyoutProps = {
  monthButtonProps: {
    'aria-label': 'Switch to month view',
  },
  nextMonthButtonProps: {
    'aria-label': 'Go to next month',
  },
  previousMonthButtonProps: {
    'aria-label': 'Go to previous month',
  },
  yearButtonProps: {
    'aria-label': 'Switch to year view',
  },
};

export const DateField = ({
  id,
  name,
  format = 'DD.MM.YYYY',
  size = 'small',
  value,
  maxDate,
  minDate,
  onChange,
  onBlur = () => {},
  label,
  disabled = false,
  helperText,
}) => (
  <ODSDatePicker
    id={id}
    name={name}
    flyoutProps={flyoutProps}
    format={format}
    inputProps={{
      disabled,
      label,
      placeholder: value,
      mode: helperText ? 'informative' : 'standard',
      supportMessageProps: {
        helperText,
        message: helperText,
      },
    }}
    maxDate={maxDate}
    minDate={minDate}
    size={size}
    defaultDate={value}
    onBlur={onBlur}
    onChange={(e) => onChange(e)}
  />
);

DateField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  format: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
};
